const menuReducer = (state=[], {type, data}) => {
    switch(type) {
        case 'SET_MENU':
            return data;
        default: 
            return state;
    }
}

export default menuReducer;